var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandartsListItems',{attrs:{"routeName":"StandartsStandart","items":_vm.list,"fields":_vm.clinRecFields,"caption":_vm.caption,"loading":_vm.loading,"error":_vm.error,"filter":_vm.filter,"paramName":"cid"}})
}
var staticRenderFns = []

export { render, staticRenderFns }